import _extends from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["label", "value", "selected"];
import React from "react";
var __jsx = React.createElement;
import { forwardRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/pro-regular-svg-icons";
/** Dropdown option row that renders a trailing check when the option is selected. */
export var FilterOptionItem = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var label = _ref.label,
    _value = _ref.value,
    selected = _ref.selected,
    others = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref
  }, others), /*#__PURE__*/React.createElement("div", {
    className: "flex items-start justify-between gap-2"
  }, /*#__PURE__*/React.createElement("span", {
    className: "break-words"
  }, label), selected ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faCheck,
    className: "mt-1 h-3.5 w-3.5 shrink-0 icon-sds-brand-default"
  }) : null));
});
FilterOptionItem.displayName = "FilterOptionItem";